import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Btn, H5 } from '../../../../../src/AbstractElements';

export const IncrementWithImageWithoutRequest = ({ data }) => {
   return (
      <Card className="rounded-0 my-2">
         <CardBody className="px-3 pt-4 pb-3">
            <div className="d-flex p-0 m-0 justify-content-between align-items-center">
               <H5 attrH5={{ className: 'mb-0' }}>{data.name}</H5>
               <div className="d-flex align-items-center">
                  <i className="icon-minus mx-2"></i>
                  <span>{data.quantity}</span>
                  <i className="icon-plus mx-2"></i>
                  <div
                     className="d-flex justify-content-center align-items-center"
                     style={{
                        marginLeft: "10px",
                        width: "50px",
                        height: "30px",
                        border: "1px solid black",
                     }}
                  >
                     Image
                  </div>
               </div>
            </div>
         </CardBody>
      </Card>
   );
};